import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router'

import { CareLogEditPage } from './-care-log-edit-page'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/agriculture/care-logs/$id/edit',
)({
    component: CareLogEditRoutePage,
})

function CareLogEditRoutePage() {
    const navigate = useNavigate()
    const { id } = useParams({
        from: '/_app/_authed/_sidebar/agriculture/care-logs/$id/edit',
    })
    const back = () => navigate({ to: '/agriculture/care-logs' })
    return (
        <CareLogEditPage
            mode="edit"
            careLogId={id}
            onSaved={back}
            onBack={back}
        />
    )
}
